import { render } from "./SelectTheam.vue?vue&type=template&id=08122c92&scoped=true&ts=true"
import script from "./SelectTheam.vue?vue&type=script&lang=ts"
export * from "./SelectTheam.vue?vue&type=script&lang=ts"

import "./SelectTheam.vue?vue&type=style&index=0&id=08122c92&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08122c92"]])

export default __exports__